export default {
  loadingText: 'Loading...',
  noDataText: 'No data found',
  itemPerPage: 'Item per page',
  title: {
    create: 'Create new ingredient',
    edit: 'Edit ingredient',
    detail: 'Ingredient'
  },
  label: {
    category: 'Category',
    status: 'Status',
    name: 'Ingredient Name',
    nameTh: 'Ingredient Name (TH)',
    nameEn: 'Ingredient Name (EN)',
    nameCn: 'Ingredient Name (CN)',
    brand: 'Brand',
    importUnit: 'Import Unit',
    subUnit: 'Sub Unit',
    pricePerUnit: 'Price Per Sub Unit',
    minQuantity: 'Min Quantity (Sub Unit)',
    maxQuantity: 'Max Quantity (Sub Unit)',
    note: 'Note',
    remaining: 'Current Quantity (Sub Unit)'
  },
  placeholder: {
    search: 'Search by number or name',
    category: 'Select category',
    status: 'Select status',
    name: 'Please input name (TH)',
    nameEn: 'Please input name (EN)',
    nameCn: 'Please input name (CN)',
    brand: 'Please input brand',
    importUnit: 'Select import unit',
    subUnit: 'Select sub unit',
    pricePerUnit: 'Please input price per unit',
    minQuantity: 'Please input min quantity',
    maxQuantity: 'Please input max quantity',
    note: 'Please input note'
  },
  header: {
    no: 'Ingredient Number',
    name: 'Ingredient Name',
    category: 'Category',
    remaining: 'Remaining',
    status: 'Status'
  },
  tooltip: {
    create: 'Create new ingredient',
    print: 'Print',
    detail: 'Ingredient',
    edit: 'Edit ingredient',
    delete: 'Delete ingredient',
    importUnit: '',
    subUnit: '',
    pricePerUnit: '',
    minQuantity: '',
    maxQuantity: '',
    remaining: ''
  },
  button: {
    cancel: 'Cancel',
    save: 'Save',
    back: 'Back',
    confirm: 'Confirm'
  },
  alert: {
    create: 'Create ingredient success !',
    edit: 'Update ingredient success !',
    delete: 'Delete ingredient success !'
  },
  status: {
    all: 'All',
    controlled: 'Volume Controlled',
    exceed: 'Volume Exceeded',
    lower: 'Volume Lowered'
  },
  modal: {
    edit: {
      title: 'Confirm Ingredient Edit',
      subtitle: 'Are you sure you want to edit ingredient ?'
    },
    delete: {
      title: 'Confirm Ingredient Delete',
      subtitle: 'Are you sure you want to delete ingredient ?'
    }
  }
}
